import * as React from "react";
import { IconButton, Icon } from "office-ui-fabric-react";
import { useImageUrl } from "../utils/useImageUrl";

export interface ILogoProps {
    onChanged?: (logo: File) => void;
    onRemove?: () => void;
    imageId?: string;
    className?: string;
    iconName?: string;
    title?: string;
    accept?: string;
}

const Logo = ({ onChanged, onRemove, imageId, className, iconName, title, accept }: ILogoProps) => {
    const inputRef = React.useRef<HTMLInputElement>(null);
    const editable = !!onChanged && !!onRemove;
    const imageUrl = useImageUrl(imageId);

    const handleChange = React.useCallback(() => {
        const files = inputRef.current!.files;
        if (files?.length) {
            onChanged!(files[0]);
        }
    }, [onChanged]);

    const handleRemove = React.useCallback(() => {
        if (inputRef.current) {
            inputRef.current.value = "";
        }
        onRemove?.();
    }, [onRemove]);

    return (
        <div
            className={`logo ${editable ? "editable" : ""} ${className || ""} ${iconName || ""}`}
            style={imageUrl ? { backgroundImage: `url(${imageUrl})` } : {}}
            title={title}
        >
            {iconName && !imageUrl && <Icon className={iconName} iconName={iconName} />}
            {editable && (
                <div className="buttons-container">
                    <IconButton title="Upload" iconProps={{ iconName: "Edit" }} onClick={() => inputRef.current!.click()} />
                    <input ref={inputRef} type="file" accept={accept} style={{ display: "none" }} onChange={handleChange} />
                    {imageId && <IconButton title="Delete" iconProps={{ iconName: "Delete" }} onClick={handleRemove} />}
                </div>
            )}
        </div>
    );
};

export default Logo;
